var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarlyAccess = function SvgEarlyAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#early_access_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.086 15.418c0-1.476-1.024-2.5-2.5-2.5s-2.5 1.024-2.5 2.5c0 1.07.093 1.672.166 1.98.043.179.175.312.355.354.307.073.91.166 1.98.166 1.475 0 2.5-1.024 2.5-2.5M12.187 16.774c-.437.35-.99.42-1.466.125-.722-.446-2.011-1.416-4.109-3.514S3.545 10 3.1 9.277c-.295-.476-.225-1.03.125-1.467.504-.63 1.492-1.757 3.388-3.654C10.055.713 16.354.713 17.82 2.18s1.465 7.764-1.978 11.207c-1.897 1.896-3.024 2.884-3.654 3.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.805 2.568c-3.51-.326-5.753.589-6.994 1.383-.772.494-.712 1.483-.036 2.092l1.668 1.503M17.49 11.082c.121 3.625-.903 5.907-1.717 7.133-.478.72-1.384.682-1.975.07l-1.524-1.58M11.25 6.25a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "early_access_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgEarlyAccess;